<template>
    <v-container>
        <v-row class="text-center">
        <!-- <v-col cols="12">
            <v-img :src="logo" class="my-3" contain height="200" />
        </v-col> -->
        <v-col class="mb-4" cols="12" lg="5" xl="5">
            <h1 class="display-2 font-weight-bold mb-3">
            O que é o Revelachá?
            </h1>

            <p class="subheading font-weight-regular">
            Revelachá é um site que vai te apoiar no Chá de Revelação do sexo do seu bebê de uma maneira muito Simples e inovadora.
            Basta cadastrar ao lado os dados do seu Chá, e você receberá um link exclusívo para distribuir para os seus convidados.
            <br><br>Clique no link abaixo e veja o vídeo para saber como funciona
            <!-- <br><a href="" target="_blank" >Em Breve</a> -->
            <br><br> <u>Vídeo Disponível em Breve</u>
            </p>
            <br><br>
            <v-row justify="center">
                <form action="https://www.instagram.com/revela.cha/">
                    <v-btn fab dark class="mx-1 listra" type="submit" formtarget="_blank">
                        <v-icon x-large>mdi-instagram</v-icon>
                    </v-btn>
                </form>
                <form action="https://fb.me/revelacha">
                    <v-btn fab dark class="mx-1 listra" type="submit" formtarget="_blank">
                    <v-icon x-large>mdi-facebook</v-icon>
                    </v-btn>     
                </form>      
            </v-row> 
        </v-col>
        <v-col class="mb-5" cols="1" >
            <hide-at breakpoint="mediumAndBelow">
                <v-divider vertical></v-divider>
            </hide-at>
            <show-at breakpoint="mediumAndAbove">
                <v-divider></v-divider>
            </show-at>
        </v-col>
        <v-col class="mb-5" cols="12" lg="6" xl="6" >
            <router-view name='second'></router-view>            
        </v-col>
        </v-row>
    </v-container>
</template>

<script>
  import {showAt, hideAt} from 'vue-breakpoints'

    export default {  
        components: { hideAt, showAt },

        created(){            
            // this.$router.replace('/createTea')
        }
    }
</script>

<style scoped>
.listra {
    /* background: repeating-linear-gradient(
        #296B74,
        #296B74 20px,
        #1C4C5A 20px,
        #1C4C5A 45px
    ); */
  background: linear-gradient(to right, #51c7fd, #f59cd3);
  background-size: cover;    
}
</style>